module.exports = __webpack_public_path__ + "img/shu.9d0d6528.png";